// extracted by mini-css-extract-plugin
export default {"block":"ExternalActions_block__c21Ba"};